import { render, staticRenderFns } from "./setUsernameModal.vue?vue&type=template&id=23ed559c"
import script from "./setUsernameModal.vue?vue&type=script&lang=js"
export * from "./setUsernameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports